import styles from './FieldWrapper.module.scss';

export interface IFieldWrapperProps {
    children: any
}

export function FieldWrapper(props: IFieldWrapperProps) {
    return (<div className={styles.host}>{props.children}</div>);
}
